import { render, staticRenderFns } from "./DocumentApprovedDataTable.vue?vue&type=template&id=d554289a&scoped=true"
import script from "./DocumentApprovedDataTable.vue?vue&type=script&lang=js"
export * from "./DocumentApprovedDataTable.vue?vue&type=script&lang=js"
import style0 from "./DocumentApprovedDataTable.vue?vue&type=style&index=0&id=d554289a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d554289a",
  null
  
)

export default component.exports